import { useTranslation } from 'react-i18next'
import {
  HomeWrapper,
  CenterAddress,
  CenterDetails,
  CenterDomiciliations,
  CenterOpeningHours,
  DomiciliationType,
  HomeLeftPart,
  TypeDetails,
  Subtitle,
  HomeContent,
  TypeNotification,
  DomiciliationTypeContent
} from './styles'
import Template from 'pages/components/Template'
import Header from 'components/Header'
import SearchBar from 'components/SearchBar'
import { Link, useHistory } from 'react-router-dom'
import ActivatedIcon from './assets/activated.png'
import WaitingIcon from './assets/waiting.png'
import CanceledIcon from './assets/canceled.png'
import DaysForwardingTile from './components/DaysForwardingTile'
import TodayMeetingsTile from './components/TodayMeetingsTile/index'
import { TODAY_MEETINGS_QUERY } from 'pages/Home/query'
import { useQuery } from '@apollo/client'
import { ParcelCollection } from 'globals/models/ParcelCollection'
import ParcelOpeningHoursUpdate from 'pages/Home/components/parcelOpeningHours/update'
import OpeningHoursUpdate from 'pages/Home/components/openingHours/update'

const Home = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const { data, refetch } = useQuery(TODAY_MEETINGS_QUERY)
  const parcelCollections = data?.parcelCollections as ParcelCollection[]

  return (
    <Template activeMenu='/'>
      {(currentUser, currentCenters) => {
        return (
          <HomeWrapper>
            <Header title={t('home.title')} currentUser={currentUser} currentCenters={currentCenters} />

            <SearchBar onSearch={(searchText) => history.push('/clients?search=' + searchText)} hideFilters />

            <HomeContent>
              <HomeLeftPart>
                <DaysForwardingTile />

                <TodayMeetingsTile parcelCollections={parcelCollections} refetch={refetch} />

                <CenterDomiciliations>
                  <Subtitle smallMargin>{t('home.domiciliations-type.subtitle')}</Subtitle>

                  <div>
                    <DomiciliationType>
                      <DomiciliationTypeContent>
                        <img alt='activated' src={ActivatedIcon} />

                        <TypeDetails>
                          <span>
                            {t('home.domiciliations-type.types.active')}
                            <b>
                              {currentCenters.length > 1
                                ? currentCenters
                                    .map((item) => item.domiciliationsActivatedCount)
                                    .reduce((prev, next) => prev + next)
                                : currentCenters[0].domiciliationsActivatedCount}
                            </b>
                          </span>

                          <Link to={'/clients?filter=activated'}>{t('home.domiciliations-type.see-list')}</Link>
                        </TypeDetails>
                      </DomiciliationTypeContent>
                    </DomiciliationType>

                    <DomiciliationType>
                      <DomiciliationTypeContent>
                        <img alt='waiting' src={WaitingIcon} />

                        <TypeDetails>
                          <span>
                            {t('home.domiciliations-type.types.waiting')}
                            <b>
                              {currentCenters.length > 1
                                ? currentCenters
                                    .map((item) => item.domiciliationsWaitingForValidationCount)
                                    .reduce((prev, next) => prev + next)
                                : currentCenters[0].domiciliationsWaitingForValidationCount}
                            </b>
                          </span>

                          <Link to={'/clients?filter=pending_partner_check'}>
                            {t('home.domiciliations-type.see-list')}
                          </Link>
                        </TypeDetails>
                      </DomiciliationTypeContent>

                      {currentCenters[0].domiciliationsWaitingForValidationCount > 0 && <TypeNotification />}
                    </DomiciliationType>

                    <DomiciliationType>
                      <DomiciliationTypeContent>
                        <img alt='canceled' src={CanceledIcon} />

                        <TypeDetails>
                          <span>
                            {t('home.domiciliations-type.types.canceled')}
                            <b>
                              {currentCenters.length > 1
                                ? currentCenters
                                    .map((item) => item.domiciliationsCanceledCount)
                                    .reduce((prev, next) => prev + next)
                                : currentCenters[0].domiciliationsCanceledCount}
                            </b>
                          </span>

                          <Link to={'/clients?filter=canceled'}>{t('home.domiciliations-type.see-list')}</Link>
                        </TypeDetails>
                      </DomiciliationTypeContent>
                    </DomiciliationType>
                  </div>
                </CenterDomiciliations>
              </HomeLeftPart>

              {currentCenters.length === 1 && (
                <CenterDetails>
                  <CenterAddress>
                    <Subtitle>{t('home.center.address')}</Subtitle>

                    <span>{currentCenters[0].fullAddress}</span>
                  </CenterAddress>

                  <CenterOpeningHours>
                    <OpeningHoursUpdate currentCenters={currentCenters} />
                    <ParcelOpeningHoursUpdate currentCenters={currentCenters} />
                  </CenterOpeningHours>
                </CenterDetails>
              )}
            </HomeContent>
          </HomeWrapper>
        )
      }}
    </Template>
  )
}

export default Home
